import React from 'react';
import { motion } from 'framer-motion';
import { Leaf } from 'lucide-react';
export function ProofSection() {
  return <section className="py-24 bg-sage-light/50 relative overflow-hidden" data-id="element-165">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-166">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="bg-white rounded-3xl p-10 md:p-16 shadow-sm border border-sage-light text-center relative" data-id="element-167">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 bg-sage text-white rounded-full flex items-center justify-center shadow-lg" data-id="element-168">
            <Leaf className="w-8 h-8" data-id="element-169" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif text-dark mb-8 mt-4" data-id="element-170">
            ¿Qué cambia en 7 días?
          </h2>

          <p className="text-xl md:text-2xl text-dark/80 leading-relaxed font-serif italic" data-id="element-171">
            "En la primera semana notarás cómo la inflamación baja, cómo tus
            niveles de energía se estabilizan y cómo tu cuerpo empieza a
            sentirse más ligero, sin la neblina mental."
          </p>

          <div className="mt-10 flex justify-center items-center gap-2 text-sage-dark font-medium" data-id="element-172">
            <span className="w-12 h-px bg-sage-dark/30" data-id="element-173"></span>
            Resultados Reales
            <span className="w-12 h-px bg-sage-dark/30" data-id="element-174"></span>
          </div>
        </motion.div>
      </div>
    </section>;
}